export default [
	{
		key: 'select',
		label: '',
		sorteable: false
	},
	{
		key: 'timestamp',
		label: 'Date/Time',
		sorteable: false
	},
	{
		key: 'userId',
		label: 'User',
		sorteable: false
	},
	{
		key: 'errorDetail',
		label: 'Error Log Details',
		sorteable: false
	},
	{
		key: 'resolvedComment',
		label: 'Comment',
		sorteable: false
	},
	{
		key: 'resolvedAzureDevOpsUrl',
		label: 'Azure Ticket',
		sorteable: false
	},
	{
		key: 'resolved',
		label: '',
		sorteable: false,
		component: 'icon'
	}
];
